import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

const Block = ({ title, children }) => (
  <Reveal className="border-b border-line pb-8 last:border-0">
    <h2 className="font-serif text-2xl font-semibold text-navy">{title}</h2>
    <div className="mt-4 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </Reveal>
);

export default function PrivacyPolicy() {
  return (
    <>
      <Seo title="Privacy Policy | HM Services" description="How HM Services collects, uses and protects the information you share through our website and inquiry forms." path="/privacy-policy" />
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="How we handle the information you share with HM Services." />
      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-3xl space-y-10 px-5 sm:px-8">
          <Block title="Information We Collect">
            <p>When you submit a form on our website (such as a property assessment, property listing or contact inquiry), we may collect your name, property name, phone number, email address, city, property details and any information you choose to share with us.</p>
          </Block>
          <Block title="Why We Collect Information">
            <p>We collect this information to understand your property and requirements, respond to your inquiries and provide relevant hospitality and digital services.</p>
          </Block>
          <Block title="How Inquiry Information Is Used">
            <p>Information you submit is used to contact you, prepare recommendations and deliver the services you request. We do not sell your information to third parties.</p>
          </Block>
          <Block title="Data Security Practices">
            <p>We follow sensible, professional practices to protect the information you share with us and limit access to those directly involved in your project.</p>
          </Block>
          <Block title="Third-Party Platforms">
            <p>Delivering our services may involve platforms such as Booking.com, Airbnb, Agoda, Expedia, Google and Tripadvisor. These platforms have their own privacy policies and terms, which govern how they handle data.</p>
          </Block>
          <Block title="Your Rights">
            <p>You may request access to, correction of, or deletion of the personal information you have shared with us by contacting us using the details below.</p>
          </Block>
          <Block title="Contact">
            <p>For any privacy-related questions, contact us at <a href={`mailto:${site.email}`} className="font-medium text-ocean">{site.email}</a>.</p>
          </Block>
        </div>
      </section>
    </>
  );
}
